import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Typography } from '@material-ui/core';

import TextField from '../../../../../../Common/UI/TextField';
import SelectTextField from '../../../../../../Common/UI/SelectTextField';

class NumberRule extends React.Component {
    static propTypes = {
        tree: PropTypes.object.isRequired,
        field: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        min: PropTypes.number,
        max: PropTypes.number
    };

    constructor (props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount(){
        const {tree, onChange} = this.props;
        const field = tree.field;
        const unit = tree.properties?.unit;
        if(tree.properties?.operator === "between" && ((tree.properties?.value0 === undefined) || (tree.properties?.value1 === undefined))) tree["isValid"] = false;
        else if(tree.properties?.operator === "between" && (tree.properties?.value0 > tree.properties?.value1)) tree["isValid"] = false; //false if operator is between and value1 less than value0
        else if(tree.properties?.operator === "between" && (tree.properties?.value0 < tree.properties?.value1)){
            if(field === "area" && (unit?.length > 0)) tree['isValid'] = true;
            if(field === "area" && (unit === undefined)) tree['isValid'] = false;
        } //true if operator is between and value1 greater than value0
        else if(tree.properties?.operator === "less" && tree?.properties?.value1) tree["isValid"] = tree['isValid'] &&  true; //true if operator is less and value1 is present
        else if(tree.properties?.operator === "greater" && tree?.properties?.value0) tree["isValid"] = tree['isValid'] && true; //true if operator is greater and value0 is present
        onChange(tree);
    }

    handleChange (event) {
        const { tree, onChange } = this.props;
        const newTree = { ...tree };
        newTree.properties = {
            ...newTree.properties,
            [event.target.name]: event.target.type === 'number' ? Number(event.target.value) : event.target.value
        };
        const field = newTree.field;
        const unit = newTree.properties?.unit;
        if(newTree.properties?.operator === "between" && ((newTree.properties?.value0 === undefined) || (newTree.properties?.value1 === undefined))) newTree["isValid"] = false;
        else if(newTree.properties?.operator === "between" && (newTree.properties?.value0 > newTree.properties?.value1)) newTree["isValid"] = false; //false if operator is between and value1 less than value0
        else if(newTree.properties?.operator === "between" && (newTree.properties?.value0 < newTree.properties?.value1)){
            if(field === "area" && (unit?.length > 0)) newTree['isValid'] = true;
            if(field === "area" && (unit === undefined)) newTree['isValid'] = false;
            else newTree["isValid"] = true;
        } //true if operator is between and value1 greater than value0
        else if(newTree.properties?.operator === "less" && newTree?.properties?.value1) newTree["isValid"] = newTree['isValid'] &&  true; //true if operator is less and value1 is present
        else if(newTree.properties?.operator === "greater" && newTree?.properties?.value0) newTree["isValid"] = newTree['isValid'] && true; //true if operator is greater and value0 is present
        onChange(newTree);
    }

    render () {
        const { tree, field, min, max } = this.props;
        const { properties } = tree;

        return (
            <>
                <SelectTextField
                    name="operator"
                    onChange={this.handleChange}
                    value={properties.operator || ''}
                    placeholder="Operator"
                    size="small"
                >
                    <MenuItem value="greater">{'Greater Than'}</MenuItem>
                    <MenuItem value="less">{'Less Than'}</MenuItem>
                    <MenuItem value="between">{'Between'}</MenuItem>
                </SelectTextField>
                {
                    (properties.operator === 'greater' || properties.operator === 'between') && 
                    <TextField
                        style={{ width: '100px' }}
                        type="number"
                        name="value0"
                        size="small"
                        onChange={this.handleChange}
                        placeholder={field.placeholder || 'Value'}
                        value={properties?.value0 === undefined || properties?.value0 === 0 ? '' : properties.value0}
                        error={properties.operator === 'greater' ? false : properties.value1 < properties.value0}
                        inputProps={{ min: min, max: max }}
                    />
                }
                {
                    (properties.operator === 'between') && <Typography color="textPrimary">
                        and
                    </Typography>
                }
                {
                    (properties.operator === 'less' || properties.operator === 'between') && 
                    <TextField
                        style={{ width: '100px' }}
                        type="number"
                        name="value1"
                        size="small"
                        onChange={this.handleChange}
                        placeholder={field.placeholder || 'Value'}
                        value={properties.value1 === undefined || properties.value1 === 0 ? '' : properties.value1}
                        error={properties.operator === 'less' ? false : properties.value1 < properties.value0}
                        inputProps={{ min: min, max: max }}
                    />
                }
            </>
        );
    }
}

export default NumberRule;